import React__default from 'react';
import TestSelectionList from './TestSelectionList.esm.js';
import styles from './TestSelection.module.esm.js';

var TestSelection = function (_a) {
    var handleDeleteTest = _a.handleDeleteTest, helperText = _a.helperText, testSelections = _a.testSelections, productType = _a.productType;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(TestSelectionList, { handleDeleteTest: handleDeleteTest, productType: productType, testSelections: testSelections }),
        helperText && React__default.createElement("p", { className: styles.helperText }, helperText)));
};

export { TestSelection as default };
//# sourceMappingURL=TestSelection.esm.js.map
